<template>
  <div class="main">
    <FormWrapper :action="route('admin.courses.trainers', { course: course.id })" method="POST">
      <div class="title-bar">
        <h1 class="mb-0">Course Trainers</h1>
        <a class="btn-back" :href="route('admin.courses.index')">
          <span class="icon icon-arrow-left"></span>
          <span class="text">Back to List</span>
        </a>
      </div>
      <div class="row no-gutters py-4">
        <div class="col-12 col-lg-8 col-xl-9">
          <div class="row no-gutters px-3 pl-lg-4 pr-lg-0 pl-xl-5">
            <div class="col-12">
              <transition name="fade">
                <Alert v-if="hasAlert" :alert="alert" />
              </transition>
            </div>
            <div class="col-12 mb-3">
              <h4 class="text-primary text-uppercase">Assign Trainers</h4>
            </div>
            <div class="col-12 col-xl-3 mb-3 pr-xl-3">
              <Field
                type="select"
                name="trainer_company"
                label="Trainer Company"
                v-model="selectedCompany"
                :options="companies"
                :hideSelectEmptyOption="true"
              />
            </div>
            <div class="col-12 col-xl-3 mb-3 pr-xl-3">
              <Field
                type="select"
                name="trainer"
                label="Trainer"
                v-model="selectedTrainer"
                :options="trainerOptions"
                :hideSelectEmptyOption="true"
              />
            </div>
            <div class="col-12 col-xl-6 mb-3 text-center text-xl-left add-btn-wrap">
              <a class="btn btn-info" href="#" @click.prevent="add()">Assign Trainer</a>
            </div>
            <div class="col-12">
              <div v-if="assigned.length > 0" class="multi-assign-values">
                <a
                  v-for="id in assigned"
                  :key="id"
                  class="pill"
                  href="#"
                  @click.prevent="remove(id)"
                >
                  <span class="text">{{ trainerName(id) }}</span>
                  <icon icon="remove" class="icon" />
                  <input type="hidden" name="trainers[]" :value="id" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-4 col-xl-3 form-button-wrapper">
          <div class="sticky-top">
            <div class="row no-gutters text-center">
              <div class="col-12 pb-3">
                <button type="submit" class="btn btn-success w-50">Save Changes</button>
              </div>
              <div class="col-12 pb-3">
                <a :href="route('admin.courses.index')" class="btn btn-danger w-50">Cancel & Exit</a>
              </div>
              <div class="col-12 pb-3">
                <a
                  :href="route('admin.courses.edit', { course: course.id })"
                  class="btn btn-info w-50"
                >Edit Course</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </FormWrapper>
  </div>
</template>

<script>
import DisplaysAlerts from "mixins/DisplaysAlerts";
export default {
  mixins: [DisplaysAlerts],
  props: {
    course: { type: Object, required: true },
    companies: { type: Array, default: () => [] },
    trainers: { type: Array, default: () => [] },
    ineligible: { type: Array, default: () => [] }
  },
  data() {
    return {
      selectedCompany: null,
      selectedTrainer: null,
      assigned: []
    };
  },
  computed: {
    trainerOptions() {
      return this.trainers.filter(t => t.company == this.selectedCompany);
    }
  },
  watch: {
    selectedCompany(val) {
      this.selectedTrainer = null;
    }
  },
  methods: {
    isAssigned(id) {
      return this.assigned.filter(a => a == id).length > 0;
    },
    add() {
      if (!this.selectedTrainer) {
        alert("Please choose a trainer before continuing.");
        return;
      } else if (this.isAssigned(this.selectedTrainer)) {
        alert("You have already assigned this trainer to the course.");
        return;
      }
      this.assigned.push(this.selectedTrainer);
    },
    remove(id) {
      let assigned = this.assigned;
      this.assigned = [];
      this.assigned = assigned.filter(a => a != id);
    },
    trainerName(id) {
      let trainer = this.trainers.filter(t => t.value == id)[0];
      return trainer.label;
    }
  },
  mounted() {
    this.assigned = this.course._trainers || [];

    if (!this.hasAlert) {
      if (this.ineligible.length > 0) {
        var error =
          "<p>The following trainers currently assigned to this course are no longer eligible to train this course:</p>";
        error +=
          "<ul class='mb-0'><li>" +
          this.ineligible.join("</li><li>") +
          "</li></ul>";
        this.showAlert("danger", error, false, "left");
      } else if (this.trainers.length === 0) {
        var error =
          "There are currently no trainers eligible to train this course";
        this.showAlert("danger", error, false, "left");
      }
    }
  }
};
</script>

<style scoped>
@media (min-width: 1200px) {
  .add-btn-wrap {
    padding-top: 30px;
  }
}
</style>